import React from 'react';
import {useSelector } from 'react-redux';

import { Grid , CircularProgress  } from '@material-ui/core'

import Post from './post/post';
import useStyles from './posts.styles';

const Posts = ({SetCurrentId}) => {
  const posts = useSelector(state => state.posts )
  const classes = useStyles();
  console.log(posts);
  return (
    !posts.length ? <CircularProgress /> : (
      <Grid className={classes.mainContainer} container alignItems='stretch' spacing={3}>
        {
          posts.map(post => (
            <Grid key={post._id} item xs={12} sm={6}>
              <Post post={post} SetCurrentId={SetCurrentId}/>
            </Grid>
          ))
        }
      </Grid>
    )
  );
};

export default Posts;
